<template>
  <div :ref="'gallery'+gallery.id">
    <!--    <ToastVoucherFreePhotos :free-photos-count="freePhotosCount"
                                :photos-in-cart-count="numMediaInCart"/>-->
    <ToastAddCartFeedback :photos-in-cart-count="numMediaInCart"
                          :qty-for-photo-package="packagePriceList.qty"
                          :price-for-all-photos="packagePriceList.price|formatCurrency(currency)"
                          @photo-package-activated="activatePackage"
                          v-if="toastCartEnabled"/>

    <div class="container" v-if="hasComingVideos">
      <AlertMessage color="primary"
                    icon="infoCircle"
                    :message="$t('pages.checkins_detail.reel_coming')"/>
    </div>

    <HeaderBar
        :title="galleryName"
        :hasPriceList="hasPriceList"
        @show-price-list="showPriceList"
        v-if="media_count > 0"/>

    <PackageCustom :data="packageCustom"
                   :currency="currency"
                   :in-cart="packageCustomInCart"
                   class="mb-4"
                   @activate-custom-package="activatePackageCustom"
                   v-if="showPackageCustom && packageCustomPosition === ctaPosition.TOP"/>

    <MediasLayout :loading="loading"
                  :pagination="pagination"
                  :paginationMode="paginationMode"
                  :medias="medias"
                  :isPaid="isPaid"
                  :gallery="gallery"
                  :digital-item-id="digitalItemId"
                  @nextPage="load"
                  @select="showGallery"
                  v-if="media_count > 0"/>

    <PackageButtons :package-price-list="packagePriceList"
                    @activate-package="activatePackage"
                    v-if="showPriceListCta"/>

    <PackageCustom :data="packageCustom"
                   :currency="currency"
                   :in-cart="packageCustomInCart"
                   class="mt-5"
                   @activate-custom-package="activatePackageCustom"
                   v-if="showPackageCustom && packageCustomPosition === ctaPosition.BOTTOM"/>

    <ModalMedia :medias="medias"
                :total-medias="totalMedias"
                :page="page"
                :pagination-mode="paginationMode"
                :is-paid="isPaid"
                :gallery-type="galleryType"
                :digital-item-id="digitalItemId"
                :ref="modalMediasGalleryId"
                :modal-id="modalMediasGalleryId"
                :gallery="gallery"
                @nextPage="load()"/>

    <ModalPriceList :modal-id="modalPriceListId"
                    :event-name="eventName"
                    :currency="currency"
                    :price-list="galleryPriceList"
                    :price-list-img="priceListImg"
                    v-if="hasPriceList"/>
  </div>

</template>


<script>
import {mapActions, mapGetters} from "vuex";
import ModalMedia from "@/domain/galleries/modals/ModaMedia.vue";
import MediasLayout from "@/domain/galleries/medias/MediasLayout.vue";
import ModalPriceList from "@/domain/galleries/modals/ModalPriceList.vue";
import {ctaPosition, galleryTypes, mediaTypes, paginationType} from "@/domain/galleries/constants";
import PriceListButton from "@/domain/galleries/components/PriceListButton.vue";
import ToastVoucherFreePhotos from "@/domain/galleries/toasts/ToastVoucherFreePhotos.vue";
import ToastAddCartFeedback from "@/domain/galleries/toasts/ToastAddCartFeedback.vue";
import PackageButtons from "@/domain/galleries/components/PackageButtons.vue";
import PackageCustom from "@/domain/galleries/components/PackageCustom.vue";
import {orderTypes} from "@/domain/cart/constants";
import HeaderBar from "@/domain/galleries/components/HeaderBar.vue";
import AlertMessage from "@/domain/core/components/AlertMessage.vue";
import galleries from "./Galleries.vue";

export default {
  name: 'Gallery',
  components: {
    AlertMessage,
    HeaderBar,
    PackageCustom,
    PackageButtons,
    ToastAddCartFeedback,
    ToastVoucherFreePhotos,
    PriceListButton,
    ModalPriceList,
    MediasLayout,
    ModalMedia
  },
  data() {
    return {
      loading: false,
      firstLoad: true,
      page: 1
    }
  },
  props: {
    gallery: {
      type: Object,
      required: true
    },
    galleryType: {
      type: String,
      required: true
    }
  },
  watch: {
    'digitalItem.media_ids': {
      handler: 'checkCartAndShowToast',
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapGetters('checkinDetail', ['checkin', 'picaCode', 'eventName', 'currency', 'showPrices']),
    ...mapGetters('galleries', ['priceList']),
    ...mapGetters('cartDigitalItems', ['getDigitalItem']),
    isPaid() {
      return this.galleryType === galleryTypes.PAID
    },
    toastCartEnabled() {
      if (!this.packagePriceList) return false
      if (!this.packagePriceList.qty) return false
      if (this.packagePriceList.qty <= 1) return false
      return this.media_count > 0
    },

    ctaPosition() {
      return ctaPosition
    },

    digitalItem() {
      return this.getDigitalItem(this.gallery.id, this.checkin.id)
    },

    digitalItemId() {
      return this.digitalItem ? this.digitalItem.id : null
    },

    numMediaInCart() {
      return this.digitalItem && this.digitalItem.media_ids ? this.digitalItem.media_ids.length : 0
    },
    packageCustomInCart() {
      return this.digitalItem && this.digitalItem.order_type.includes(orderTypes.PHOTOPACKAGE)
    },

    priceListImg() {
      return this.gallery.price_list && this.gallery.price_list.price_list_img ? this.gallery.price_list.price_list_img : null
    },

    galleryPriceList() {
      if (!this.gallery.price_list) return false
      return this.priceList({items: this.gallery.price_list.items});
    },
    packagePriceList() {
      if (!this.galleryPriceList) return false
      return this.galleryPriceList.find(price => price.last)
    },
    showPriceListCta() {
      if (!this.gallery.price_list) return false
      if (this.packagePriceList && this.packagePriceList.price <= 0) return false
      return this.gallery.price_list.show_cta
    },
    modalMediasGalleryId() {
      return `modalMediasGallery-${this.galleryType}-${this.gallery.id}`
    },
    modalPriceListId() {
      return "modalPriceList-" + this.gallery.id
    },
    medias() {
      return this.gallery.medias.results
    },
    pagination() {
      return this.gallery.medias.pagination
    },
    hasNextPage() {
      return this.pagination.page_number <  this.pagination.num_pages
    },
    totalMedias() {
      return this.pagination.total
    },
    galleryName() {
      return this.gallery.name || this.$t('pages.checkins_detail.default_gallery')
    },
    media_count() {
      return this.gallery.media_count
    },
    page_size() {
      return this.pagination.page_size
    },
    hasPriceList() {
      if (!this.isPaid) return false
      if (this.showPrices === false) return false
      return this.gallery.price_list && this.gallery.price_list.items && this.gallery.price_list.items.length > 0
    },
    packageCustom() {
      return this.gallery && this.gallery.price_list && this.gallery.price_list.custom_cta
    },
    packageCustomPosition() {
      return this.gallery && this.gallery.price_list && this.gallery.price_list.cta_position
    },
    showPackageCustom() {
      return this.packageCustom && this.isPaid
    },
    hasComingVideos() {
      if (this.isPaid) return false
      return this.gallery.medias.results.some(media => {
            return media.media_type === mediaTypes.VIDEO
                && media.download_hd_url === null
                && media.download_sd_url !== null
          }
      )
    },
    paginationMode() {
      return this.pagination.num_pages > 4 ? paginationType.NUMBER : paginationType.INFINITE
    }

  },
  async mounted() {
    // await this.load()
  },
  methods: {
    ...mapActions('galleries', ['fetchMediasByGallery', "fetchGalleries", "checkNewMedia"]),
    ...mapActions('cartDigitalItems', ['createDigitalItem', 'setDigitalItemType', "addAllMediasToDigitalItem"]),

    async load(numPage) {
      if (numPage === undefined) {
        if ((this.loading || !this.hasNextPage) && !this.firstLoad) return
      }

      this.loading = true
      this.firstLoad = false

      // numPage is undefined when is load more, otherwise is the page number
      const page = numPage || this.page
      const params = {page: page, page_size: this.page_size}
      if (this.isPaid) params.paid = true
      if (this.galleryType === galleryTypes.FAVORITE) params.favorite = true

      await this.fetchMediasByGallery({
        gallery_type: this.galleryType,
        gallery_id: this.gallery.id,
        checkin_id: this.checkin.id,
        append: numPage === undefined,
        params: params
      })

      if (this.paginationMode === paginationType.NUMBER && numPage) {
        await this.$nextTick()
        this.scrollToTop()
      } else {
        this.page += 1
      }
      this.loading = false
    },
    scrollToTop() {
      const element = this.$refs['gallery' + this.gallery.id]
      if (!element) return

      const elementPosition = element.offsetTop;
      const navbar = document.getElementById('navbar')
      const offset = navbar.offsetHeight
      const offsetPosition = elementPosition - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      })
    },
    showGallery(index) {
      this.$refs[this.modalMediasGalleryId].show(index)
    },
    showPriceList() {
      this.$bvModal.show(this.modalPriceListId)
    },
    checkCartAndShowToast() {
      if (!this.showPriceListCta) return
      if (this.packagePriceList.qty === null) return
      if (this.numMediaInCart === this.packagePriceList.qty || this.numMediaInCart === this.packagePriceList.qty - 1) {
        this.$bvToast.show('toast-add-cart-action-feedback')
      }
    },

    async activatePackage(orderType = orderTypes.PHOTOPACKAGE) {
      try {
        if (this.digitalItemId) {
          await this.setDigitalItemType({digitalItemId: this.digitalItemId, params: {order_type: orderType}})
        } else {
          await this.createDigitalItem({
            order_type: orderType,
            media_ids: [],
            checkin_id: this.checkin.id,
            gallery_id: this.gallery.id
          })
        }
        await this.$router.push({name: 'checkout'})
      } catch (error) {
        const responseError = error.response
        if (responseError.status === 400) {
          if (responseError.data.code === 'cart_currency_mismatch') {
            this.$bvModal.show('modal-currency-mismatch')
          } else if (responseError.data.code === 'purchase_disabled') {
            this.$bvToast.toast(responseError.data.detail, {
              title: this.$t('collage_photo_item.purchase_not_available'),
              headerClass: 'd-block pt-2',
              autoHideDelay: 5000,
              toaster: 'b-toaster-top-center'
            });
          }
        }
        throw error
      }
    },

    async activatePackageCustom() {
      try {
        await this.addAllMediasToDigitalItem({
          checkin_id: this.checkin.id,
          gallery_id: this.gallery.id
        })
        await this.$router.push({name: 'checkout'})
      } catch (error) {
        this.$bvToast.toast(this.$t('collage_photo_item.purchase_not_available'), {
          headerClass: 'd-block pt-2',
          variant: 'danger',
          autoHideDelay: 5000,
          toaster: 'b-toaster-top-center'
        });
      }
    },

  },
}
</script>
